import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { Agent } from './../models/index';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class AgentService implements Resolve<Agent[]> {
  constructor(
    private apiCallService: ApiCallService
  ) { }

  getAgents(): Promise<Agent[]> {
    return this.apiCallService.get('/agents');
  }

  resolve(route: ActivatedRouteSnapshot): Promise<Agent[]> {
    return this.getAgents();
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/agent.service.ts